import { render, staticRenderFns } from "./Completed.vue?vue&type=template&id=33d1996c&"
import script from "./Completed.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Completed.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Completed.vue?vue&type=style&index=0&id=33d1996c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports